const STATUS_ICONS: Record<string, string> = {
  "รับผ้าแล้ว": "📥",
  "กำลังดำเนินการ": "🧺",
  "พร้อมรับ": "✅",
  "รับไปแล้ว": "🎉",
};

export function statusIcon(status: string): string {
  return STATUS_ICONS[status] ?? "🧺";
}

/** แสดงเวลาแบบไทย (พ.ศ.) */
export function formatThaiDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("th-TH", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/** ปรับเบอร์ก่อนส่ง API */
export function normalizePhone(input: string): string {
  let p = input.replace(/[\s\-]/g, "");
  if (p.startsWith("+66")) p = "0" + p.slice(3);
  else if (p.startsWith("66") && p.length >= 11) p = "0" + p.slice(2);
  return p;
}

export function isValidThaiPhone(normalized: string): boolean {
  return /^0[0-9]{8,9}$/.test(normalized);
}
